export const PARTNER_TYPES = [
  { label: "Supplier", value: "SUPPLIER" },
  { label: "Transporter", value: "TRANSPORTER" },
  { label: "Farmer", value: "FARMER" },
  { label: "Brand", value: "BRAND" },
  { label: "Processor", value: "PROCESSOR" },
  { label: "Storage", value: "STORAGE" },
];
